import { Injectable } from '@angular/core';

import { SearchConfigService } from '../../search-results/services/search-config.service';
import { ClassNames } from '../../shared/icon-font/icon-font-classes.utility';
import { IconFontType } from '../../shared/icon-font/icon-font-type.enum';

export interface SettingModel {
    IconUnicodeCodepointCssClass: string;
    RelatedSearchQueries: Array<string>;
    Title: string;
    Url: string;
}

@Injectable({
    providedIn: 'root'
})
export class Settings {

    private settings: Array<SettingModel>;

    constructor(
        private readonly searchConfigService: SearchConfigService
    ) {
        this.initializeSettingList();
    }

    public getSettingList(): Array<SettingModel> {
        return this.settings;
    }

    public initializeSettingList() {

        // Sorted by urls
        this.settings = [
            {
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.PlayerSettings),
                RelatedSearchQueries: ['account', 'my account', 'my profile', 'change password', 'update password', 'password', 'setting'],
                Title: this.searchConfigService.config.resources.SettingSearchMyAccountText,
                Url: 'https://account.microsoft.com'
            },
            {
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.Devices3),
                RelatedSearchQueries: ['device', 'manage devices', 'my device'],
                Title: this.searchConfigService.config.resources.SettingSearchManageDevicesText,
                Url: 'https://account.microsoft.com/devices/'
            },
            {
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.ContactCardSettings),
                RelatedSearchQueries: ['profile', 'my profile', 'picture', 'my picture', 'change my email', 'birthday', 'country', 'physical address', 'language', 'change language', 'language settings', 'change culture', 'culture'],
                Title: this.searchConfigService.config.resources.SettingSearchMyProfileText,
                Url: 'https://account.microsoft.com/profile/'
            },
            {
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.Download),
                RelatedSearchQueries: ['get office', 'install office', 'install word', 'install powerpoint', 'install excel', 'install outlook', 'download office'],
                Title: this.searchConfigService.config.resources.SettingSearchInstallOfficeText,
                Url: 'https://account.microsoft.com/services/office/install'
            },
            {
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.Office2),
                RelatedSearchQueries: ['buy office', 'subscription', 'renew', 'renew subscription'],
                Title: this.searchConfigService.config.resources.SettingSearchBuyOrRenewOfficeText,
                Url: 'https://www.microsoft.com/microsoft-365/buy/microsoft-365-family'
            },
            {
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.GiftCard),
                RelatedSearchQueries: ['redeem gift card', 'gift code'],
                Title: this.searchConfigService.config.resources.SettingSearchRedeemGiftCardText,
                Url: 'https://redeem.microsoft.com/'
            },
            {
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.Permissions),
                RelatedSearchQueries: ['renew', 'product key', 'key', 'activate'],
                Title: this.searchConfigService.config.resources.SettingSearchEnterProductKeyText,
                Url: 'https://setup.office.com'
            }
        ];
    }

    private getBaseCSSClass() {
        return ClassNames.SvgIconCssClass + ' ' + ClassNames.FluentIconCssClass;
    }
}
